export const swiperConfig = {
  slidesPerView: 2,
  initialSlide: 2,
};
